import { FC, ReactNode } from "react";
import { StyledButton } from "./styles";
import { LoadingOutlined } from "@ant-design/icons";
import {
  BUTTON_HEIGHT_LARGE,
  DisplaySize,
  FONT_SIZE,
  MENU_COLORS,
} from "@lhd/constants";

interface EditButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  height?: number;
  displaySize?: DisplaySize;
  name?: string;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  iconRight?: ReactNode;
  style?: React.CSSProperties;
  type?: string;
  isFull?: boolean;
}

const ButtonCommon: FC<EditButtonProps> = ({
  onClick,
  height,
  displaySize,
  name,
  className,
  style,
  disabled,
  icon,
  iconRight,
  loading,
  type = "button",
  isFull,
}) => {
  return (
    <StyledButton isFull={isFull}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          if (disabled || loading) return;
          onClick && onClick(e);
        }}
        disabled={!!disabled || !!loading}
        className={`button-edit-common ${!disabled && type} ${className} ${
          loading ? "btn-loading" : ""
        }`}
        style={{
          height: displaySize ? BUTTON_HEIGHT_LARGE[displaySize] : height,
          ...(displaySize && { fontSize: FONT_SIZE[displaySize] }),
          ...(type === "delete-btn"
            ? {
                backgroundColor: MENU_COLORS.NORMAL_DELETE,
                color: MENU_COLORS.TEXT_WHITE,
              }
            : {}),
          ...style,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="button-content">
          {loading && <LoadingOutlined className="button-loading" />}
          {icon && <div className="button-icon">{icon}</div>}
          <span className="button-text">{name}</span>
          {iconRight && <div className="button-icon">{iconRight}</div>}
        </div>
      </button>
    </StyledButton>
  );
};

export default ButtonCommon;
